import React from 'react'
import { Box, Tooltip } from '@mui/material'
import { getLucideIcon } from './lucideIcons'

/**
 * Renders a lucide icon by its kebab-case name.
 *
 * Unknown names (an allowlisted icon this build does not bundle) render a
 * small labelled placeholder so the value stays visible and selectable
 * rather than disappearing.
 */
function PathwayIcon({ name, size = 18, color, sx }) {
  const Icon = getLucideIcon(name)
  if (Icon) {
    return (
      <Box
        component="span"
        sx={{ display: 'inline-flex', alignItems: 'center', flexShrink: 0, color, ...sx }}
      >
        <Icon size={size} aria-label={name} />
      </Box>
    )
  }
  return (
    <Tooltip title={`Icon "${name || ''}" is not bundled in this admin build`}>
      <Box
        component="span"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          width: size,
          height: size,
          borderRadius: '4px',
          border: '1px dashed',
          borderColor: 'text.disabled',
          color: 'text.disabled',
          fontSize: Math.max(8, Math.round(size * 0.5)),
          fontFamily: 'monospace',
          lineHeight: 1,
          overflow: 'hidden',
          ...sx,
        }}
      >
        {(name || '?').slice(0, 2)}
      </Box>
    </Tooltip>
  )
}

export default PathwayIcon
